import React from "react";
import { Row, Col } from "reactstrap";
import "./calculate-premium.scss";
import YesNoQuestion from "../../../components/common/buyflow/yesNoQuestion";
import MultiSelectQuestion from "../../../components/common/buyflow/multiSelectQuestion";
import InnerShadowButton from "../../../components/common/buttons/innerShadow";

class CalculatePremium extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPlan: props.match.params["plan"],

      currentScreen: 1,
      checked: true,
      selected: ["self", "spouse"],
    };
  }
  moveToNextScreen() {
    if (this.state.currentScreen > 2) {
      this.props.history.push(
        "/product/" + this.state.selectedPlan + "/register"
      );
    } else {
      this.setState({
        currentScreen: this.state.currentScreen + 1,
      });
    }
  }
  render() {
    return (
      <div className="calculate-container">
        {/* <YesNoQuestion
          title="Are you a politically exposed person?"
          checked={this.state.checked}
          onAnswered={(value) => {
            console.log(value);
            this.setState({
              checked: value,
            });
          }}
        /> */}
        {/* <MultiSelectQuestion
          title="Pick out the family members"
          subTitle="Select family members you want to insure (for Health) under your Family Toffee Plan"
          checked={this.state.checked}
          onAnswered={(selectedArray) => {
            this.setState({
              selected: selectedArray,
            });
          }}
          options={[
            {
              title: "Self",
              value: "self",
            },
            {
              title: "Spouse",
              value: "spouse",
            },
            {
              title: "Daughter",
              value: "daughter",
            },
            {
              title: "Son",
              value: "son",
            },
          ]}
          selected={this.state.selected}
        /> */}
        <div className="header d-flex justify-content-between">
          <h3 className="font-weight-bold m-0">
            Calculate your monthly payment
          </h3>
          {/* <span> */}
          <i class={"fas fa-times  fa-md "} color="danger" />
          {/* </span> */}
        </div>

        {this.state.currentScreen === 1 && (
          <div className="screen screen-one">
            <h3 className="font-weight-bold">Kindly share your details</h3>
            put code for Ist
          </div>
        )}
        {this.state.currentScreen === 2 && (
          <div className="screen screen-one ">
            <MultiSelectQuestion
              title="Pick out the family members"
              subTitle="Select family members you want to insure (for Health) under your Family Toffee Plan"
              checked={this.state.checked}
              onAnswered={(selectedArray) => {
                this.setState({
                  selected: selectedArray,
                });
              }}
              options={[
                {
                  title: "Self",
                  value: "self",
                },
                {
                  title: "Spouse",
                  value: "spouse",
                },
                {
                  title: "Daughter",
                  value: "daughter",
                },
                {
                  title: "Son",
                  value: "son",
                },
              ]}
              selected={this.state.selected}
            />
            <hr />
            <YesNoQuestion
              title="Do you consume tobacco?"
              subTitle="(As a thumb rule, you may want to choose YES if you’ve smoked or consumed tobacco products regularly in the last 12 months) "
              checked={this.state.checked}
              onAnswered={(value) => {
                console.log(value);
                this.setState({
                  checked: value,
                });
              }}
            />
          </div>
        )}
        {this.state.currentScreen === 3 && (
          <div className="screen screen-three"></div>
        )}
        <div className="footer d-flex justify-content-end">
          <InnerShadowButton
            clicked={(e) => {
              this.moveToNextScreen();
            }}
            title="Next"
            active={true}
          />
        </div>
      </div>
    );
  }
}

export default CalculatePremium;
